module.exports = __webpack_public_path__ + "static/img/banner-02.a76b679.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner-02.jpg
// module id = ZLes
// module chunks = 1